
import { RoutineNavigation } from "./RoutineNavigation";
import { Database } from "@/integrations/supabase/types";
import { RoutineHeader } from "./RoutineHeader";

type Weekday = Database["public"]["Enums"]["weekday"];

interface RoutineTabHeaderProps {
  routines: any[];
  currentIndex: number;
  showExerciseForm: boolean;
  currentRoutine: any;
  showRemoveButton: boolean;
  planId: string;
  isPersonalPlan: boolean;
  canEdit: boolean;
  onTabChange: (value: string) => void;
  onToggleExerciseForm: () => void;
  onRemoveRoutine?: (routineId: string) => Promise<void>;
  handleUnlinkRoutine: (routineId: string) => Promise<void>;
  hideDaySelector?: boolean;
}

export const RoutineTabHeader = ({
  routines,
  currentIndex,
  showExerciseForm,
  currentRoutine,
  showRemoveButton,
  planId,
  isPersonalPlan,
  canEdit,
  onTabChange,
  onToggleExerciseForm,
  onRemoveRoutine,
  handleUnlinkRoutine,
  hideDaySelector,
}: RoutineTabHeaderProps) => {
  return (
    <div className="flex flex-col gap-4">
      <RoutineNavigation
        routines={routines}
        currentIndex={currentIndex}
        onTabChange={onTabChange}
      />
      {currentRoutine && (
        <RoutineHeader
          name={currentRoutine.name}
          showRemoveButton={showRemoveButton}
          showExerciseForm={showExerciseForm}
          onToggleExerciseForm={onToggleExerciseForm}
          onUnlinkRoutine={isPersonalPlan ? onRemoveRoutine! : handleUnlinkRoutine}
          routineId={currentRoutine.id}
          isPersonalPlan={isPersonalPlan}
          canEdit={canEdit}
          day={currentRoutine.day}
          hideDaySelector={hideDaySelector}
        />
      )}
    </div>
  );
};
